import React from "react";
import Heading from "../../elements/heading";
import BodyText from "../../elements/body-text";
import classNames from "classnames";
import Hotspot from "../../react-components/hotspot";

const HotspotContainer = props => {
  const hotspotContainer = model => {
    const hotspotClasses = classNames(
      "hotspot",
      `padding-top-${(model.componentPadding && model.componentPadding.top) ||
        "default"}`,
      `padding-bottom-${(model.componentPadding &&
        model.componentPadding.bottom) ||
        "default"}`,
      {
        "grid-story": model.gridType === "story",
        grid: model.gridType === "normal"
      }
    );
    const overlineClasses = classNames("overline", model.alignContent);
    const headingClasses = classNames(
      "title show-on-scroll",
      model.alignContent
    );
    const bodyTextClasses = classNames("body-text", model.alignContent);

    return (
      <div
        className={hotspotClasses}
        style={{
          background: model.backgroundColor || "inherit"
        }}
      >
        {model.overlineText && (
          <span className={overlineClasses}>{model.overlineText}</span>
        )}

        {model.heading && (
          <Heading
            className={headingClasses}
            typographyClass="type-h1"
            {...model.heading}
          />
        )}

        <BodyText className={bodyTextClasses} html={model.body} />
        <Hotspot {...model} />
      </div>
    );
  };

  if (props.gridType === "story") {
    return <div className={"grid"}>{hotspotContainer(props)}</div>;
  } else {
    return hotspotContainer(props);
  }
};

export default HotspotContainer;
